import React, { useState } from "react";
import ThemeControls from "../../Component/AllThemesControl";
import { APIGET } from "../../services/APIServices";
function Create() {
  const { useStyles } = ThemeControls;
  const classes = useStyles();
  const [msg,setMsg]=useState('')
  const [results, setResults] = useState([]);
  const [password, setPassword] = useState('');
const [isAuthenticated, setIsAuthenticated] = useState(false);

  const apiEndpoints = [
    { id: 1, name: 'User', endpoint: 'user' },
    { id: 2, name: 'Organization', endpoint: 'organization' },
    { id: 3, name: 'Country', endpoint: 'country' },
    { id: 4, name: 'Role', endpoint: 'role' },
    // Add more API endpoints as needed
  ];

  async function settingData(url) {
    
    return await APIGET(url.endpoint+'/cache').then(data => {
      try {
        if (data.statusCode==="Success") {
            setResults((prevResults) => [...prevResults, data.data]);
        }else{
            setMsg('Error fetching data')
        }
    } catch (error) {
        console.error('Error fetching data:', error);
      } 
    })
}
function clearAll(){
    apiEndpoints.map((api) => (
        settingData(api)  
    ))
}

const handlePasswordSubmit = () => {
    if (password === 'password') { // Replace 'your_password_here' with the actual password
      setIsAuthenticated(true);
      setMsg('');
    } else {
      setMsg('Incorrect password');
    }
  };

  return (
        <div className={classes.main}>
          <div style={{ textAlign: 'center', marginTop: '50px' }}>
            <h1>Remove backend cache.</h1>   
              <div>
                <div style={{ display: 'flex', justifyContent: 'center', gap: '10px', marginBottom: '20px' }}>
                  {apiEndpoints.map((api) => (
                    <button
                      key={api.id}
                      onClick={() => settingData(api)}
                      style={{
                        padding: '10px 20px',
                        fontSize: '16px',
                        cursor: 'pointer',
                        borderRadius: '20px',
                        background: '#86bbe5',
                        border: '1px solid #1a94f5',
                        color: '#fff',
                      }}
                    >
                      {api.name}
                    </button>
                  ))}
                  <button
                    onClick={() => clearAll()}
                    style={{
                      padding: '10px 20px',
                      fontSize: '16px',
                      cursor: 'pointer',
                      borderRadius: '20px',
                      background: '#c283cd',
                      border: '1px solid #af53bf',
                      color: '#fff',
                    }}
                  >
                    All Clear
                  </button>
                </div>
                <p style={{ fontSize: '18px', color: 'red' }}>{msg}</p>
                <ul style={{ listStyleType: 'none', padding: 0 }}>
                  {results.map((result, index) => (
                    <li key={index} style={{ fontSize: '18px', margin: '5px 0', color: 'green' }}>{result}</li>
                  ))}
                </ul>
              </div>
          </div>
        </div>
      );
}

export default Create;
